import React, { useState } from 'react';
import FormInput from './FormInput';
import PasswordInput from './PasswordInput';
import { useNavigate } from 'react-router-dom';

const LoginForm = ({ onLogin }) => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loginMessage, setLoginMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors((prevErrors) => ({ ...prevErrors, [e.target.name]: '' }));
    setLoginMessage('');
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.username) tempErrors.username = 'Username is required';
    if (!formData.password) tempErrors.password = 'Password is required';

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginMessage('');
    if (!validate()) {
      setLoginMessage('Please Fill the Details first');
      return;
    }

    try {
      const res = await fetch('https://peakybalvinder.pythonanywhere.com/api/auth/login', {
      // const res = await fetch('http://127.0.0.1:5001/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        setLoginMessage('Login successful!');
        const token = data.token;
        if (token) {
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(data.user));
        }

        onLogin(token, data.user);
        navigate('/dashboard');
      } else {
        setLoginMessage(data.message || 'Login failed');
        console.error('Login failed:', data.message || 'Unknown error');
      }
    } catch (error) {
      setLoginMessage('Server error. Please ensure the backend is running and try again later.');
      console.error('Error during login:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="bg-white p-10 rounded-3xl shadow-2xl w-full max-w-md border border-gray-100 transform transition-all duration-300 ease-in-out hover:shadow-3xl">
        <form onSubmit={handleSubmit} className="flex flex-col gap-y-6">
          <h2 className="text-4xl font-extrabold text-center text-blue-700 mb-6 tracking-wide">LOGIN</h2>

          <FormInput
            label="Username"
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            error={errors.username}
            placeholder="Your username"
          />

          <PasswordInput
            name="password"
            label="Password"
            value={formData.password}
            onChange={handleChange}
            error={errors.password}
            placeholder="Your password"
          />

          {loginMessage && (
            <p className={`text-center text-sm font-medium ${loginMessage.includes('successful') ? 'text-green-700 bg-green-50 p-2 rounded-lg' : 'text-red-700 bg-red-50 p-2 rounded-lg'}`}>
              {loginMessage}
            </p>
          )}

          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-300 transition duration-300 ease-in-out transform hover:scale-105 shadow-xl hover:shadow-2xl mx-auto block w-full sm:w-auto"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
